import {
  THREAT_INTEL_EXPORT_EXCEL_LIST_REQUESTED,
  THREAT_INTEL_EXPORT_EXCEL_LIST_PROCESSING,
  THREAT_INTEL_EXPORT_EXCEL_LIST_SUCCESSED,
  THREAT_INTEL_EXPORT_EXCEL_LIST_FAILED,

  } from '../../constants/actionTypes';
   
  const initialState = {
    listData: {},
    isProcessing: null,
    isSuccess: null,
    hasErrors: null,
  };
  
  export const threatIntelExcelExport = (state = initialState, action) => {
    switch (action.type) {
      case THREAT_INTEL_EXPORT_EXCEL_LIST_REQUESTED: {
        return {
          ...state,
          listData: null,
          hasErrors: null,
          isProcessing: true,
          isSuccess: null,
        };
      }
      case THREAT_INTEL_EXPORT_EXCEL_LIST_PROCESSING: {
        return {
          ...state,
          listData: null,
          hasErrors: null,
          isProcessing: true,
          isSuccess: null,
        };
      }
      case THREAT_INTEL_EXPORT_EXCEL_LIST_SUCCESSED: {
        return {
          listData: action.data,
          hasErrors: null,
          isProcessing: false,
          isSuccess: true,
        };
      }
      case THREAT_INTEL_EXPORT_EXCEL_LIST_FAILED: {
        return {
          listData: action.data,
          hasErrors: true,
          isProcessing: false,
          isSuccess: null,
        };
      }
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default threatIntelExcelExport;
  